<style lang="css">

</style>
<template lang="html">
<transition name="popup" v-on:enter="onEnter" v-on:after-leave="afterLeave">
<div ref="rootdom" class="wx-popup-root" :style="rootStyle" v-show="show">
	<div class="wx-popup-mask" v-show="isShowMask"></div>
	<div class="wx-popup-wrap">
        <div class="wx-popup" :style="{width:width+'px'}">
            <div class="wx-popup-header">
                <slot name="header">
                    <span class="wx-popup-title">{{title}}</span>
                </slot>
                <i v-if="close" class="wxfont wxfont-close" @click.stop="doClose"></i>
            </div>
            <div class="wx-popup-body">
                <slot></slot>
            </div>
            <div class="wx-popup-footer" v-if="footer">
                <slot name="footer">
                    <el-button type="primary" @click.stop="doCheck">确定</el-button>
                    <el-button type="default" @click.stop="doCancel">取消</el-button>
                </slot>
            </div>
        </div>
	</div>
</div>
</transition>
</template>
<script>
import "./popup.less"

import qt_util from '@libs/qt/util.js';

export default {
	props: {
		show:{
			type:Boolean,
			default:false
		},
		//弹窗层级
		zindex:{
			type:String,
			default:'9000'
        },
        //弹窗标题
        title:{
            type:String,
            default:''
        },
        //是否有右上角关闭
        close:{
            type:Boolean,
            default:true
        },
         //弹窗宽度
        width:{
            type:Number,
            default:600
        },
        //确认回调函数
        beforeConfirm:{
            type:Function,
            default:null
        },

        //是否包含footer
        footer:{
            type:Boolean,
            default:true
        },
	},
	data: function(){
		return {
			id: qt_util.unique(),
			isShow:false
		}
	},
	created: function(){

	},
	mounted:function(){
		this.handleClose();
	},
	computed: {
		rootStyle:function(){
			return {
				zIndex: parseInt(this.zindex)
			}
		},
		isShowMask:function(){
			return this.id == this.$store.state.popupId;
		}
	},
	methods: {
		//向全局声明自己在最顶层
		onEnter:function(el,done){
			this.$store.commit('pushPopupId',this.id);
			done();
		},
		//通知全局取消自己
		afterLeave:function(){
			this.$store.commit('popPopupId',this.id);
		},

		//处理默认的事件
		handleClose:function(){
			var _this = this;
			var rootDom = this.$refs.rootdom;
			if(!rootDom){
				return;
			}
			//处理关闭
			var closeDoms = rootDom.querySelectorAll('[data-close]');
			for(var i=0;i<closeDoms.length;i++){
				closeDoms[i].onclick=function(){
					_this.doClose();
				}
			}
		},
		doClose:function(){
            this.$emit('update:show',false);
            this.$emit('close');
        },

        doCheck:function(){
            let {beforeConfirm} = this;
            let promise = beforeConfirm&&beforeConfirm();
            if(promise){
                //如果确认函数返回布尔值
                if(typeof promise=='boolean'){
                    if(promise){
                        this.doConfirm();
                    }
                }else{
                    //如果确认函数返回的是promise
                    promise.then(()=>{
                       this.doConfirm();
                    },()=>{
                        //do nothing
                    });
                }
            }else{
                this.doConfirm();
            }
        },

        doConfirm:function(){
            this.$emit('update:show',false);
            this.$emit('confirm');
        },

        doCancel:function(){
            this.$emit('update:show',false);
            this.$emit('cancel');
        }
	},
	watch: {

	}
}
</script>



// WEBPACK FOOTER //
// src/components/core/popup/Popup.vue